export const FULFILLED = 'FULFILLED';
export const CARD_SEARCH_RESULT = 'CARD_SEARCH_RESULT';


/** WEBPACK FOOTER **
 ** ./src/constants/action-constants.js
 **/